// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ModalVideo_wrapper__3pHGo","show":"ModalVideo_show__2ItJ6","modal":"ModalVideo_modal__2jk47"};